export class LogVisualizarDocumentoPrestacaoConta {
    id = 0;
    idSocio = 0;
    idDocumento = 0;
    cpfAssociado = '';
    nomeAssociado = '';
    dataHora = new Date();
}